import{jsx as e}from"react/jsx-runtime";import o from"./assets/page-container.module.scss";const r=({children:a})=>e("div",{className:o.pageContainer,children:a});export{r as PageContainer};
